import type { SettingsNavItem } from '../components/app-shell/AppShell';
import {
  IconCalendarHeart,
  IconCoins,
  IconGiftCard,
  IconHeartHandshake,
  IconReceiptDollar,
  IconSchool,
  IconUsersGroup,
} from '@tabler/icons-react';
import {
  BookHeart,
  BookOpenCheck,
  HeartHandshake,
  PiggyBank,
} from 'lucide-react';

export type TempNavItem = SettingsNavItem & {
  route: string;
};

export const TEMP_NAV_LABEL = 'Temp';

export const STAFF_TEMP_NAV_ITEMS: TempNavItem[] = [
  { id: 'temp-academics', label: 'Academics', icon: IconSchool, route: '/school/academics' },
  { id: 'temp-finance', label: 'Finance', icon: IconCoins, route: '/school/finance' },
  { id: 'temp-substitutes', label: 'Substitutes', icon: IconUsersGroup, route: '/school/substitutes' },
  { id: 'temp-tuition-admin', label: 'Tuition Admin', icon: IconReceiptDollar, route: '/administrator/tuition' },
  { id: 'temp-school-camps', label: 'Camps', icon: IconCalendarHeart, route: '/school/camps' },
  { id: 'temp-school-donations', label: 'Donations', icon: IconHeartHandshake, route: '/school/donations' },
  { id: 'temp-school-tip-a-teacher', label: 'Tip a Teacher', icon: IconGiftCard, route: '/school/tip-a-teacher' },
];

export const PARENT_TEMP_NAV_ITEMS: TempNavItem[] = [
  { id: 'temp-parent-tip-a-teacher', label: 'Tip a Teacher', icon: BookHeart, route: '/parent/portal/tip-a-teacher' },
  { id: 'temp-parent-donations', label: 'Donations', icon: HeartHandshake, route: '/parent/portal/donations' },
  { id: 'temp-parent-parnes-hayom', label: 'Parnes HaYom', icon: BookOpenCheck, route: '/parent/portal/parnes-hayom' },
  { id: 'temp-parent-camps', label: 'Camps', icon: PiggyBank, route: '/parent/portal/camps' },
];

const resolveTempNavId = (pathname: string, items: TempNavItem[]): string | null => {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  const match = [...items]
    .sort((left, right) => right.route.length - left.route.length)
    .find((item) => normalized === item.route || normalized.startsWith(`${item.route}/`));
  return match?.id ?? null;
};

export const resolveStaffTempNavId = (
  pathname: string,
  items: TempNavItem[] = STAFF_TEMP_NAV_ITEMS,
): string | null =>
  resolveTempNavId(pathname, items);

export const resolveParentTempNavId = (
  pathname: string,
  items: TempNavItem[] = PARENT_TEMP_NAV_ITEMS,
): string | null =>
  resolveTempNavId(pathname, items);

export const STAFF_TEMP_ROUTE_MAP = new Map<string, string>(
  STAFF_TEMP_NAV_ITEMS.map((item) => [item.id, item.route]),
);

export const PARENT_TEMP_ROUTE_MAP = new Map<string, string>(
  PARENT_TEMP_NAV_ITEMS.map((item) => [item.id, item.route]),
);
